/**
 * Thin wrapper around NEXT_PUBLIC_ENV so that tests can mock it.
 *
 * Background: next/jest inlines process.env.NEXT_PUBLIC_* at transform time
 * using the values from .env files.  That means dynamically setting
 * process.env.NEXT_PUBLIC_ENV = "PROD" inside a test has no effect on already-
 * compiled source code.  By routing through this module, tests can do:
 *
 *   jest.mock("~/utils/envConfig", () => ({ isProductionEnv: jest.fn(() => true) }))
 *
 * …and the source code under test will correctly see the mocked value.
 */
export const isProductionEnv = (): boolean => process.env.NEXT_PUBLIC_ENV === "prod";
